import React from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { Loader, Toast, Fallback, ErrorBoundary } from "@sicredi/react";

import "./global.scss";
import App from "#/App";
import { onResponse } from "#/utils/request";
/* import { OidcProvider, OidcSecure } from "@axa-fr/react-oidc";
import oidcConfig from "./oidcConfig"; */
import { startApiMockServer } from "./api/__mocks__";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { version } from "./version";

const loadingComponent = () => <Loader show fullScreen />;

const ROOT = document.getElementById("root")!;

function unmountRender(element: React.ReactElement) {
  unmountComponentAtNode(ROOT);
  render(element, ROOT);
}

unmountRender(loadingComponent());

if (!!process.env.REACT_APP_MIRAGE && process.env.REACT_APP_MIRAGE === "true") {
  startApiMockServer({});
}

onResponse((response) => {
  function handleClose() {
    window.auth.actions.logout();
    window.location.reload();
  }

  if (response?.status === 401) {
    unmountRender(
      <Fallback title="Acesso negado" onClose={handleClose}>
        Você não possui autorização para acessar essa aplicação.
      </Fallback>
    );
  }
});

const authentication = {
  async authenticate() {
    return {};
  },
  getJwtIdToken() {
    return { payload: "user" };
  },
  getAccessToken() {
    const tokensStorage = JSON.parse(
      sessionStorage.getItem("oidc.default") || ""
    );

    const token = tokensStorage?.tokens?.accessToken;
    return token;
  },

  logout() {
    return {};
  },
};

authentication
  .authenticate()
  .then((auth) => {
    window.appVersion = version;

    window.auth = {
      ...auth,
      user: authentication.getJwtIdToken()!.payload,
      get token() {
        return authentication.getAccessToken();
      },
      actions: {
        logout: authentication.logout.bind(authentication),
      },
    };

    unmountRender(
      <ErrorBoundary>
        <Toast />
        <App />
      </ErrorBoundary>
    );
  })
  .catch((err) => {
    if (err?.status && err?.status !== "URL_NOT_VERIFIED") {
      unmountRender(<Fallback />);
    }
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
